import useTrans from '@hooks/useTrans'
import { WContainer, WImage } from '@components/atoms'
import styles from './Superfici.module.sass'

interface Props {
  collezione: any // CollezioneNode
  className?: string
}

const Superfici = (props: Props) => {
  const { collezione = undefined, className = '' } = props
  const t = useTrans()

  return /*collezione?.superfici?.length || */ !!collezione.shadeVariations?.length ||
    !!collezione.destinazioni?.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer className={styles.container}>
        {/* <div className={styles.firstContainer}>
          {!!collezione.nome && <h2 className={styles.title}>{t('Superfici')}</h2>}
        </div> */}

        {/* <div className={styles.secondContainer}>
          {collezione.superfici.length > 0 &&
            collezione.superfici.map((superficie) => (
              <div className={styles.superficieBox} key={superficie.id}>
                {superficie.nome && <h3 className={styles.superficieTitle}>{superficie.nome}</h3>}
                <div className={styles.superficieInfo}>
                  {superficie?.scivolositaNome && superficie?.scivolositaLabel && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.scivolositaNome}{' '}
                      <span className={styles.superficieInfoItemValue}>
                        {superficie.scivolositaLabel}
                      </span>
                    </p>
                  )}

                  {superficie?.specificheAbcNome && superficie?.specificheAbcLabel && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.specificheAbcNome}{' '}
                      <span className={styles.superficieInfoItemValue}>
                        {superficie.specificheAbcLabel}
                      </span>
                    </p>
                  )}

                  {superficie?.dcof && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.dcof}{' '}
                      <span className={styles.superficieInfoItemValue}>{t('DCOF')}</span>
                    </p>
                  )}

                  {superficie?.bcra && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.bcra}{' '}
                      <span className={styles.superficieInfoItemValue}>{t('B.C.R.A')}</span>
                    </p>
                  )}

                  {superficie?.pendoloAS4586 && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.pendoloAS4586}{' '}
                      <span className={styles.superficieInfoItemValue}>{t('AS 4586')}</span>
                    </p>
                  )}

                  {superficie?.pendoloBS7976 && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.pendoloBS7976}{' '}
                      <span className={styles.superficieInfoItemValue}>{t('BS 7976')}</span>
                    </p>
                  )}

                  {superficie?.pendoloUNE41901 && (
                    <p className={styles.superficieInfoItemKey}>
                      {superficie.pendoloUNE41901}{' '}
                      <span className={styles.superficieInfoItemValue}>{t('UNE 41901')}</span>
                    </p>
                  )}
                </div>
              </div>
            ))}
        </div> */}

        <div className={styles.thirdContainer}>
          {!!collezione.shadeVariations?.length && (
            <div className={styles.thirdContainerItem}>
              <h3 className={styles.thirdContainerItemTitle}>{t('Shade variations')}</h3>
              {collezione.shadeVariations.map((shadeVariation, idx) => (
                <div className={styles.thirdContainerItemContent1}>
                  <WImage
                    className={styles.thirdContainerItemContent1Image}
                    src={shadeVariation.imageUrl}
                    alt={shadeVariation?.imageAlt}
                    maxWidth={85}
                    maxHeight={85}
                  />
                  <p className={styles.thirdContainerItemContent1Text}>{shadeVariation.nome}</p>
                </div>
              ))}
            </div>
          )}
          {!!collezione.destinazioni?.length && (
            <div className={styles.thirdContainerItem}>
              <h3 className={styles.thirdContainerItemTitle}>{t("Destinatari d'uso")}</h3>
              <div className={styles.thirdContainerItemContent2}>
                {collezione.destinazioni.map((destinazione, idx) => (
                  <div className={styles.thirdContainerItemContent2Item}>
                    <WImage
                      className={styles.thirdContainerItemContent1Image}
                      src={destinazione.imageUrl}
                      alt={destinazione?.imageAlt}
                      maxWidth={85}
                      maxHeight={85}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default Superfici
